/* Consent gate for third-party YouTube media in the theme. */
(function () {
  'use strict';

  var listeners = new Set();
  var players = new Map();
  var lastAllowed = null;
  var attempts = 0;
  var noticeText = 'This video is provided by an external video service. Allow Marketing in Cookie preferences to play it.';

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function allowed() {
    try {
      var api = privacyApi();
      return !!(
        api &&
        typeof api.marketingAllowed === 'function' &&
        typeof api.saleOfDataAllowed === 'function' &&
        api.marketingAllowed() === true &&
        api.saleOfDataAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function openPreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }
    var preferenceButton = document.querySelector('[data-cookie-preferences]');
    if (preferenceButton) preferenceButton.click();
  }

  function createNotice() {
    var notice = document.createElement('div');
    notice.className = 'fbm-consent-media-notice';
    notice.setAttribute('role', 'note');

    var message = document.createElement('p');
    message.className = 'fbm-consent-media-notice__text';
    message.textContent = noticeText;

    var button = document.createElement('button');
    button.className = 'fbm-consent-media-notice__button';
    button.type = 'button';
    button.textContent = 'Cookie preferences';
    button.addEventListener('click', openPreferences);

    notice.appendChild(message);
    notice.appendChild(button);
    return notice;
  }

  function showPlayerNotice(element) {
    element.classList.add('fbm-consent-media-placeholder');
    element.replaceChildren(createNotice());
  }

  function clearPlayerNotice(element) {
    if (!element.classList.contains('fbm-consent-media-placeholder')) return;
    element.replaceChildren();
    element.classList.remove('fbm-consent-media-placeholder');
  }

  function showIframeNotice(frame) {
    frame.hidden = true;
    if (frame.__fbmConsentNotice && frame.__fbmConsentNotice.isConnected) return;
    var notice = createNotice();
    frame.parentNode.insertBefore(notice, frame);
    frame.__fbmConsentNotice = notice;
  }

  function clearIframeNotice(frame) {
    frame.hidden = false;
    if (frame.__fbmConsentNotice && frame.__fbmConsentNotice.isConnected) {
      frame.__fbmConsentNotice.remove();
    }
    frame.__fbmConsentNotice = null;
  }

  function syncIframes(isAllowed) {
    document.querySelectorAll('iframe[data-fbm-consent-src]').forEach(function (frame) {
      if (isAllowed) {
        if (!frame.hasAttribute('src')) {
          frame.setAttribute('src', frame.getAttribute('data-fbm-consent-src'));
        }
        clearIframeNotice(frame);
      } else {
        frame.removeAttribute('src');
        showIframeNotice(frame);
      }
    });
  }

  function syncPlyrPlaceholders(isAllowed) {
    document.querySelectorAll('[data-plyr-provider="youtube"], [data-plyr-provider="vimeo"]').forEach(function (element) {
      if (isAllowed) clearPlayerNotice(element);
      else showPlayerNotice(element);
    });
  }

  function revokePlayers() {
    players.forEach(function (entry, element) {
      try {
        if (typeof entry.destroy === 'function') entry.destroy();
        else if (entry.player && typeof entry.player.destroy === 'function') entry.player.destroy();
      } catch (error) {
        // A missing player cleanup must not prevent other media from being blocked.
      }
      if (element && element.dataset) delete element.dataset.fbmPlayerInitialized;
    });
    players.clear();
  }

  function notify(isAllowed) {
    listeners.forEach(function (listener) {
      try {
        listener(isAllowed);
      } catch (error) {
        // Keep other consent listeners running if one theme feature fails.
      }
    });
  }

  function refresh(forceNotify) {
    var isAllowed = allowed();
    var changed = lastAllowed !== isAllowed;

    if (!isAllowed) {
      revokePlayers();
      syncIframes(false);
      syncPlyrPlaceholders(false);
      if (changed || forceNotify) notify(false);
    } else {
      syncIframes(true);
      syncPlyrPlaceholders(true);
      if (changed || forceNotify) notify(true);
    }

    lastAllowed = isAllowed;
  }

  function start() {
    var api = privacyApi();
    if (!api && attempts++ < 20) {
      window.setTimeout(start, 250);
      return;
    }

    refresh(true);
    if (api && typeof api.subscribe === 'function') {
      api.subscribe('visitorConsentCollected', function () { refresh(false); });
    } else {
      document.addEventListener('visitorConsentCollected', function () { refresh(false); });
    }
  }

  function boot() {
    refresh(true);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { start(); }
      );
    } else {
      start();
    }
  }

  window.FBMPrivacyGate = {
    allowed: allowed,
    onChange: function (listener) {
      listeners.add(listener);
      if (lastAllowed !== null) listener(lastAllowed);
      return function () { listeners.delete(listener); };
    },
    registerPlayer: function (element, player, destroy) {
      players.set(element, { player: player, destroy: destroy });
      element.dataset.fbmPlayerInitialized = 'true';
    },
    requestPreferences: function (container) {
      if (container && !container.querySelector('.fbm-consent-media-notice')) {
        container.appendChild(createNotice());
      }
      openPreferences();
    }
  };

  var observer = new MutationObserver(function (records) {
    if (lastAllowed === null) return;
    var relevant = records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches('iframe[data-fbm-consent-src], [data-plyr-provider="youtube"], [data-plyr-provider="vimeo"]') ||
          node.querySelector('iframe[data-fbm-consent-src], [data-plyr-provider="youtube"], [data-plyr-provider="vimeo"]')
        );
      });
    });
    if (relevant) refresh(false);
  });

  function observe() {
    if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  observe();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
